import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { showUpload, hideUpload } from '../actions/app-state';
import UploadIcon from './UploadIcon';

const styles = {
    container: {
        flex: '0 1 34px',
    },
    button: {
        transition: 'opacity 0.3s ease-out',
    },
    disabled: {
        cursor: 'not-allowed',
        opacity: 0.5,
    },
};

export class UploadButton extends Component {
    static propTypes = {
        color: PropTypes.string,
        disabled: PropTypes.bool,
        dispatch: PropTypes.func.isRequired,
        uploadVisible: PropTypes.bool,
    };

    static defaultProps = {
        disabled: false,
    };

    handleClick = () => {
        const { dispatch, uploadVisible } = this.props;

        if (uploadVisible) {
            dispatch(hideUpload());
        } else {
            dispatch(showUpload());
        }
    };

    render() {
        const { disabled } = this.props;
        const buttonStyles = {
            ...styles.button,
        };

        if (disabled) {
            Object.assign(buttonStyles, {
                ...styles.disabled,
            });
        }

        return (
            <div style={styles.container}>
                <label
                    className="btn btn-link image-upload"
                    style={buttonStyles}
                    onClick={!disabled ? this.handleClick : null}
                >
                    <UploadIcon color={this.props.color} />
                </label>
            </div>
        );
    }
}

export default connect(
    ({ appState: { uploadVisible } }) => {
        return {
            uploadVisible,
        };
    },
    null,
    null,
    {
        forwardRef: true,
    },
)(UploadButton);
